
















import { Component, Vue, Watch } from 'vue-property-decorator';
import Banner from '@/components/banner/Bannerwrap.vue';
import Gallery from '@/components/gallery/Gallery.vue';
import Title from './Title.vue';

import axios from 'axios';
import { getProductsUrl } from '@/util/lang.ts';
import imgs from '@/util/imgs.ts';

@Component({
  components: {
    Banner,
    Gallery,
    Title,
  },
})
export default class Productlist extends Vue {
  // initial data
  private imgs = imgs;
  private iszoom: boolean = false;

  private products: object[] = [];

  @Watch('$store.state.lang')
  private onLangChanged() {
    this.fetchData();
  }

  // lifecycle hook
  private mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      this.iszoom = true;
    });

    this.fetchData();
  }

  private fetchData() {
    const url = getProductsUrl(this.$store.state.lang, 11);
    window.console.log(url);

    axios.get(url).then((res: any) => {
      window.console.log(res.data.proarr);
      this.products = res.data.proarr;
      // proarr item 字段
      // ID: "19"
      // PRONAME: "服装用ePTFE膜"
      // SMALLPIC: "2018112622190722.jpg"
    });
  }
}
